import React from "react"

import styles from "./DateInput.module.scss"

/**
 * @param {String} [className] - additional className to add
 * @param {Date} value - date value
 * @param {Function} onChange - onChange event handler (should be setState from parent)
 * @param {String} [size] - md/lg; default is lg
 */
const DateInput = props => {
    const size = props.size || "lg"
    const randomId = Math.random().toString(36).substring(7);
    const disabled = props.disabled ? 'disabled' : '';
    const maxDate = props.maxDate;
    return (
        <div
            className={`${styles["date-input"]} ${
                styles[`date-input-${size}`]
            } ${props.className || ""}`}
        >
            <input disabled={disabled} id={`${randomId}`} max={maxDate} type="date" value={props.value} onChange={props.onChange} />
            <label htmlFor={`${randomId}`}>
                {/* <i className={`fal fa-calendar-alt ${styles["date-input-icon"]}`} /> */}
            </label>
        </div>
    )
}

export default DateInput
